import { createSelector } from 'reselect';
import { orderBy } from 'lodash';
import { StoreState } from '../../store-interfaces';
import { RecipientsOrderBy, TrackingType } from './types';

const getRecipients = (state: StoreState) => state.campaigns.trackings;
const getContactsSortBy = (state: StoreState) =>
  state.recipientsTableState.recipientsOrderBy;

const getOrderedContacts = (
  recipients: TrackingType,
  recipientsOrderBy: RecipientsOrderBy,
) => {
  const { orderDir, keyName } = recipientsOrderBy;
  if (!recipients) return recipients;
  const users = recipients.trackings;
  return orderBy(users, [user => user[keyName].toLowerCase()], [orderDir]);
};

export const orderedRecipientsSelector = createSelector(
  [getRecipients, getContactsSortBy],
  getOrderedContacts,
);
